import { __ } from '@wordpress/i18n';
import {InspectorControls} from '@wordpress/block-editor';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import {VayuBlocksHeaderTab, usePanelSettings} from '@vayu-blocks';
import SlideSettings from './SlideSettings';

const panelKeys = [
	'slide-image',
	'slide-height',
];

const initialPanels = {
    slide: 'slide-image',
    advanced: '',
};

const panelOptions = [
	{ label: __( 'Setting', 'vayu-blocks' ), value: 'slide', icon: 'slide'},
	{ label: __('Advanced', 'vayu-blocks'), value: 'advanced', icon: 'colorpalette',},
		
];

const PanelSettings = ({attributes,setAttributes,isSelected,clientId}) => {

	const { tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'slide' });

	const tabComponents = {
		slide: <SlideSettings attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		advanced:<VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId} exclude={['Cursor', 'cursorFollower']} openPanels={openPanels} onTogglePanel={onTogglePanel}/>
	};

    return (
		
		<>
			{isSelected && (
				<InspectorControls>
					<div className='th-block-ins th-button-panel'>

						<VayuBlocksHeaderTab 
							value={ tab }
							options={panelOptions}
							onChange={ setTab }
						/>

						{tabComponents[tab]}

					</div>
				</InspectorControls>  
			)}

    	</>
		
	);
}

export default PanelSettings;